// Import colors
import { colors } from 'components/theme/pure_ott_theme/colors';

// Import helpers
import { phoneCodes } from 'helpers/phone_codes';

export const AUTH_METHODS = {
	GOOGLE: 'google',
	FACEBOOK: 'facebook',
	APPLE: 'apple',
	PHONE: 'phone'
};

const { GOOGLE, FACEBOOK, PHONE, APPLE } = AUTH_METHODS;

const allowedAuthProviders =
	process.env.REACT_APP_FIREBASE_AUTH?.split(',') ?? [];

export const APPLE_AUTH_PROVIDER = 'OAuthProvider';
export const APPLE_AUTH_PROVIDER_ID = 'apple.com';

export const authenticationMethods = [
	{ name: GOOGLE, authProvider: 'GoogleAuthProvider' },
	{ name: FACEBOOK, authProvider: 'FacebookAuthProvider' },
	{ name: APPLE, authProvider: APPLE_AUTH_PROVIDER }
];

export const RECAPTCHA_CONTAINER_ID = 'recaptcha-container';

export const RECAPTCHA_TYPE = 'normal';

export const AUTH_FIELDS_NAMES = {
	PHONE_NUMBER: 'phone_number',
	CODE: 'code',
	COUNTRY: 'country',
	DIAL_CODE: 'dialCode'
};

export const COUNTRY_FLAG_CDN =
	'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3';

export const UNKNOWN_DIAL_CODE = 'N/A';

export const getButtonColor = (method, isPureOtt) => {
	let backgroundColor, textColor;
	switch (method) {
		case FACEBOOK:
			backgroundColor = colors.firebase_auth.facebook;
			textColor = colors.white;
			break;

		case APPLE:
			backgroundColor = isPureOtt ? colors.white : colors.black;
			textColor = isPureOtt ? colors.black : colors.white;
			break;

		case GOOGLE:
			backgroundColor = isPureOtt
				? colors.white
				: colors.firebase_auth.google.grayBcg;
			textColor = colors.black;
			break;

		case PHONE:
			backgroundColor = colors.firebase_auth.phone;
			textColor = colors.white;
			break;

		default:
			backgroundColor = colors.white;
			textColor = colors.black;
			break;
	}

	return { backgroundColor, textColor };
};

export const getDialCode = (dialCode) => (dialCode ? `+${dialCode}` : 'N/A');

export const fetchUserLocalization = async () => {
	const response = await fetch('http://ip-api.com/json');
	const data = await response.json();
	return data;
};

export const getPhoneNumberFormInitialValues = (userCountryCode) => {
	const userCountry = phoneCodes.find(({ iso2 }) => iso2 === userCountryCode);
	const defaultCountry = phoneCodes.find(({ iso2 }) => iso2 === 'us');

	return {
		country: userCountry ? userCountry.iso2 : defaultCountry.iso2,
		dialCode: userCountry ? userCountry.dialCode : defaultCountry.dialCode,
		phone_number: ''
	};
};

export const authProviders = authenticationMethods.filter((method) =>
	allowedAuthProviders.includes(method.name.toLowerCase())
);
